export default "__VITE_ASSET__raTgU5zz__"